import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getInvites({ dealId }) {
  try {
    const invites = yield call(API.getInvites, dealId);
    yield put({ type: actionTypes.INVITES_GET_SUCCESS, invites });
  } catch (error) {
    yield put({ type: actionTypes.INVITES_GET_ERROR, error });
  }
}

export function* getInvite({ dealId, inviteId }) {
  try {
    const invite = yield call(API.getInvite, dealId, inviteId);
    if (invite.id) {
      yield put({ type: actionTypes.INVITE_GET_SUCCESS, invite });
    } else {
      yield put({ type: actionTypes.INVITE_GET_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.INVITE_GET_ERROR, error });
  }
}

export function* createInvite({ dealId, invite }) {
  try {
    const result = yield call(API.createInvite, dealId, invite);
    if (result.error) {
      yield put({ type: actionTypes.INVITE_CREATE_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.INVITE_CREATE_SUCCESS, invite: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.INVITE_CREATE_ERROR, error });
  }
}

export function* updateInvite({ invite }) {
  try {
    const result = yield call(API.updateInvite, invite);
    if (result.id) {
      yield put({ type: actionTypes.INVITE_UPDATE_SUCCESS, invite: result });
    } else {
      yield put({ type: actionTypes.INVITE_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.INVITE_UPDATE_ERROR, error });
  }
}

export function* deleteInvite({ dealId, inviteId }) {
  try {
    yield call(API.deleteInvite, dealId, inviteId);
    yield put({ type: actionTypes.INVITE_DELETE_SUCCESS, inviteId });
  } catch (error) {
    yield put({ type: actionTypes.INVITE_DELETE_ERROR, error });
  }
}

export function* getInviteByKey({ key }) {
  try {
    const invite = yield call(API.getInviteByKey, key);
    if (invite.id) {
      yield put({ type: actionTypes.INVITE_GET_BY_KEY_SUCCESS, invite });
    } else {
      yield put({ type: actionTypes.INVITE_GET_BY_KEY_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.INVITE_GET_BY_KEY_ERROR, error });
  }
}

export function* getUserInvites({ userId }) {
  try {
    const invites = yield call(API.getUserInvites, userId);
    yield put({ type: actionTypes.INVITES_USER_GET_SUCCESS, invites });
  } catch (error) {
    yield put({ type: actionTypes.INVITES_USER_GET_ERROR, error });
  }
}

export function* resendDealInvitation({ dealId, inviteId }) {
  try {
    const result = yield call(API.resendDealInvitation, dealId, inviteId);
    yield put({ type: actionTypes.RESEND_DEAL_INVITATION_SUCCESS, result });
  } catch (error) {
    yield put({ type: actionTypes.RESEND_DEAL_INVITATION_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/invites.js